type RecordItems = {
    defecation: string;
    defecationAndUrine: string;
    urine: string;
    none: string;
};

export const recordColors: RecordItems = {
    defecation: '#AE8315',
    defecationAndUrine: '#FF7152',
    urine: '#72FBFD',
    none: '#C4C4C4',
};
export const getRecordNames = (t: (key: string, fallback: string) => string): RecordItems => ({
    defecation: `${t('stool', '排便')}：${t('yes', '有')}`,
    defecationAndUrine: `${t('stool', '排便')}・${t('urine', '排尿')}：${t('yes', '有')}`,
    urine: `${t('urine', '排尿')}：${t('yes', '有')}`,
    none: `${t('stool', '排便')}・${t('urine', '排尿')}：${t('no', '無')}`,
});
